import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  bodyText: {
    fontWeight: 'normal',
    color: theme.palette.neutralPrimary,
    lineHeight: '1.43',
  },
  listBullet: {
    listStyleType: 'disc',
    marginLeft: pxToRem(18),
  },
  support: {
    width: pxToRem(20),
    height: pxToRem(20),
    color: theme.palette.themePrimary,
    fontSize: pxToRem(16),
  },
});
